import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaTrash } from "react-icons/fa";
import api from '../../api/manage_database/FlowMeterReq';
import SelectThoroughfare from "../../components/SelectThroughfare";
import SelectPlace from "../../components/SelectPlace";
import SelectTypeLines from "../../components/SelectTypeLines";
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';
import { FcOk } from "react-icons/fc";
import { MdCancel } from "react-icons/md";


const FlowMeterDelete = () => {

    const [flowMeters, setFlowMeters] = useState([]);
    const [selectedFlowMeter, setSelectedFlowMeter] = useState('');
    const [selectedPlace, setSelectedPlace] = useState('');
    const [places, setPlaces] = useState([]);
    const [selectedThoroughfare, setSelectedThoroughfare] = useState('');
    const [thoroughfares, setThoroughfares] = useState([]);
    const [selectedTypeLine, setSelectedTypeLine] = useState('');
    const [typeLines, setTypeLines] = useState([]);
    
    const [flowMeterData, setFlowMeterData] = useState();

    const navigate = useNavigate();

    const handleDelete = () => {
        const filteredFlowMeter = flowMeters
                                        .filter(
                                            flowmeter => flowmeter.location_id.place === selectedPlace &&
                                            flowmeter.location_id.thoroughfare === selectedThoroughfare && 
                                            flowmeter.location_id.type_line === selectedTypeLine)[0]

        const filteredFlowMeterId = filteredFlowMeter.id
        
        const msg = `Are you sure to delete Flow Meter: ${filteredFlowMeter.location_id.place} ${filteredFlowMeter.location_id.thoroughfare} ${filteredFlowMeter.location_id.type_line}?`;

        const toastId = toast.warning(msg, {
            style: {width: '20rem'},
            action: <FcOk onClick={() => handleAction(filteredFlowMeterId, toastId)} style={{fontSize: '4rem'}}/>,
            cancel: <MdCancel onClick={() => handleCancel(toastId)} style={{fontSize: '4rem', color: 'red'}}/>,
            duration: 10000
        });
    }

    const handleAction = (flowMeter, toastId) => {
        setSelectedFlowMeter(flowMeter);
        toast.dismiss(toastId);
    }

    const handleCancel = (toastId) => {
        toast.warning(
            'Operation cancelled!',
            {
                id: toastId,
                action: null,
                cancel: null,
                duration: 5000
            }
        );
    }

    useEffect(() => {
        const fetchFlowMeters = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setFlowMeters(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchFlowMeters();
    }, []);

    useEffect(() => {
        const fetchRecord = async () => {
            try {
                const response = await api.get(`record/${selectedFlowMeter}`, {withCredentials: true});
                if (response.data.success) {
                    setFlowMeterData(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
                    
            } catch (err) {
                console.log(err.response);
            }
        }
        if (selectedFlowMeter) {
            fetchRecord();
        }
    }, [selectedFlowMeter])

    useEffect(() => {
        const deleteRecord = async () => {
            try {
                const response = await api.delete(`record/${selectedFlowMeter}`, {withCredentials: true});
                if (response.data.success) {
                    toast.success(`${response.data.message}`);
                    navigate(
                        `../record/${selectedFlowMeter}`,
                        {
                            state: {
                                deleteRecordMessage: 'Deleted record from database!',
                                anotherTypeOfPage: true,
                                data: flowMeterData
                            }
                        }
                    )
                } else {
                    toast.error('Something go wrong! Maybe check internet connection');
                }
            } catch (err) {
                console.log(err.response);
            }
        }

        if (flowMeterData) {
            deleteRecord();
        }
    }, [flowMeterData]);

    useEffect(() => {
        const handlePlaces = () => {
            const newplaces = [...new Set(flowMeters.map(item => item.location_id.place))] 
            return newplaces.map((name, index) => ({id: index+1, name: name}));
            
        }
        if (flowMeters.length > 0) {
            setPlaces(handlePlaces());
        }
    }, [flowMeters])

    useEffect(() => {
        const filterPlaces = () => {
            const newthoroughfare = flowMeters.filter(flowmeter => flowmeter.location_id.place === selectedPlace).map((fl, index) => ({id: index+1, name: fl.location_id.thoroughfare}))
            return newthoroughfare.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setThoroughfares(filterPlaces())
        }
    }, [selectedPlace])

    useEffect(() => {
        const filterPlacesAndThoroughfares = () => {
            const newTypeLines = flowMeters
                                    .filter(flowmeter => flowmeter.location_id.place === selectedPlace && flowmeter.location_id.thoroughfare === selectedThoroughfare)
                                    .map((fl, index) => ({id: index+1, name: fl.location_id.type_line}))
            
            return newTypeLines.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setTypeLines(filterPlacesAndThoroughfares())
        }
    }, [selectedThoroughfare])

    return (
        <div className='flow-meter-delete-container'>
            <h2 className='flow-meter-delete-title'>Flow Meter</h2>
            <div className='flow-meter-delete-card'>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Place:
                    </label>
                    <SelectPlace
                        places={places}
                        selectedPlace={selectedPlace}
                        setSelectedPlace={setSelectedPlace}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Section:
                    </label>
                    <SelectThoroughfare
                        thoroughfares={thoroughfares}
                        selectedThoroughfare={selectedThoroughfare}
                        setSelectedThoroughfare={setSelectedThoroughfare}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Type line:
                    </label>
                    <SelectTypeLines
                        LocationTypeLines={typeLines}
                        selectedlocationTypeLine={selectedTypeLine}
                        setSelectedLocationTypeLine={setSelectedTypeLine}
                    />
                </div>
                <button className='flow-meter-delete-button' onClick={handleDelete}>Delete &nbsp; <FaTrash /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    );
        
};

export default FlowMeterDelete;